import { Grid } from "@mui/material";
import React from "react";
import { Button } from "../../../../../controls";
import { formatDate } from "hooks";

const RegisterDtls = ({ handleSubmit, loading, activeReg }) => {
  return activeReg ? (
    <div className="bg-white rounded-[20px]">
      <div className="!mb-[15px] flex flex-wrap gap-2 justify-between items-center pb-[5px] p-[10px] border-b">
        <div>
          <span className="text-[20px] tracking-wide font-medium text-gray-500 border-left">
            Register Details
          </span>
        </div>
        <Button
          onClick={handleSubmit}
          loading={loading}
          className="max-sm:w-full"
        >
          Close Register
        </Button>
      </div>

      <Grid container spacing={2} className="p-[15px]">
        <Grid item xs={12} md={4} className="d-grid">
          <span className="text-[11px]  uppercase mb-[5px] text-gray-400">
            Outlet
          </span>
          <span className="text-[16px] text-gray-500 font-medium">
            {activeReg.outlet ? activeReg.outlet.outletName : ""}
          </span>
        </Grid>
        <Grid item xs={12} md={4} className="d-grid">
          <span className="text-[11px]  uppercase mb-[5px] text-gray-400">
            Register
          </span>
          <span className="text-[16px] text-gray-500 font-medium">
            {activeReg.register ? activeReg.register.name : ""}
          </span>
        </Grid>
        <Grid item xs={12} md={4} className="d-grid">
          <span className="text-[11px]  uppercase mb-[5px] text-gray-400">
            Opening time
          </span>
          <span className="text-[16px] text-gray-500 font-medium">
            {formatDate(activeReg.openingTime)}
          </span>
        </Grid>
      </Grid>
    </div>
  ) : (
    ""
  );
};

export default RegisterDtls;
